import React from "react"

import { FloorActionsOverlayView } from "./FloorActionsOverlayView"
import { useFloorActionsOverlayViewModel } from "./hooks/useFloorActionsOverlayViewModel"

export interface FloorActionsOverlayPayload {
  projectID: string
  floorID: string
}

interface FloorActionsOverlayProps {
  payload: FloorActionsOverlayPayload
}

export const FloorActionsOverlay = React.memo(
  ({ payload }: FloorActionsOverlayProps) => (
    <FloorActionsOverlayView {...useFloorActionsOverlayViewModel(payload)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    FLOOR_ACTIONS_OVERLAY: FloorActionsOverlayPayload
  }
}
